var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-success page-action",attrs:{"href":_vm.href,"target":"_blank","disabled":_vm.disabled}},[_c('i',{staticClass:"fa fa-file-excel-o"}),_vm._v(" "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }